module.exports = __webpack_public_path__ + "static/img/newYearTopLeftAvater@2x.204eb74.png";


//////////////////
// WEBPACK FOOTER
// ./static/newStatic/img/newYear/newYearTopLeftAvater@2x.png
// module id = NCp8
// module chunks = 88